import styled from "styled-components";
import { Row, Col, Select } from "antd";
import Input from "../../../Common/Components/Input";
import DownAngle from "../../../../assets/img/icons/DownAngle.svg";
import Cross from "../../../../assets/img/icons/cross.svg";
import TickNormal from "../../../../assets/img/icons/tickNormal.svg";
import crossNormal from "../../../../assets/img/icons/crossNormal.svg";
import EditIcon from "../../../../assets/img/icons/Edit.svg";

const { Option } = Select;

const CreateNewList: React.FC = (props) => {
  return (
    <Wrapper>
      <div className="header-section margin-top-xl">
        <div className="second-row padding-bottom-lg padding-bottom-tab-xl">
          <h4>
            New
            <br />
            Smartlist
          </h4>
          <span className="cross">
            <img src={Cross} />
          </span>
        </div>
      </div>
      <div className="margin-bottom-md scrollable">
        <Row gutter={26}>
          <Col className="gutter-row py-3" span={24}>
            <div className="edit-wrapper-two pt-4">
              {/* Toggle editable-active class */}
              <span className="name-two">
                <h2 id="asset_name" className="asset-name-two new-campaign">
                  New list name here
                </h2>
                <span
                  style={{
                    paddingLeft: "15px",
                    cursor: "pointer",
                  }}
                >
                  <div className="tooltip">
                    <img src={EditIcon} alt="edit" />
                    <span className="tooltiptext">Edit</span>
                  </div>
                </span>
                <div className="editable">
                  <Input type="text" placeholder="Name your new campaign" />
                  <span className="save">
                    <img src={TickNormal} alt="save" />
                  </span>
                  <span className="cancel">
                    <img src={crossNormal} alt="cancel" />
                  </span>
                </div>
              </span>
            </div>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Disc Profile</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Disc Archetype</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Role</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Employed by</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Industry</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Concepts they’re interested in</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Entities they’re interested in</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
          <Col className="gutter-row py-3" span={24}>
            <h4 className="main-title">Keywords they click on</h4>
            <Select defaultValue="0" className="select-dropdown">
              <Option value="0">Select one or more…</Option>
              <Option value="1">Last name</Option>
              <Option value="2">Web</Option>
            </Select>
          </Col>
        </Row>
      </div>
      <div className="footer-sider">
        <span className="footer-btn mr">Cancel</span>
        <span className="footer-btn filled-success">Save</span>
      </div>
    </Wrapper>
  );
};

export default CreateNewList;

const Wrapper = styled.div`
  padding: 0 20px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 0 0px;
  }
  .second-row {
    padding-left: 20px;
  }
  .main-title {
    color: #67696a;
    font-size: 18px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    margin: 0;
  }
  label {
    margin: 0 0 6px 0;
    &.check-label {
      color: #7e7e7e;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
    }
  }
  input {
    padding: 5px 10px;
  }
  .cross {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .edit-wrapper-two {
    display: flex;
    position: relative;
    &.editable-active {
      .editable {
        display: block;
      }
    }
    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .editable {
      position: absolute;
      top: 15px;
      left: 0;
      width: 100%;
      display: none;
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 8px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 7px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
    }
    .new-campaign {
      color: #9b9b9b;
      font-size: 22px;
      margin-bottom: 0px;
      display: inline-block;
      font-family: 'Roboto Slab', serif;
    }
    .edit-icon {
      margin-left: 10px;
      cursor: pointer;
    }
    &.editable-active {
      .editable {
        display: block;
        width: 100%;
      }
    }
  }
  .select-dropdown {
    width: 100%;
    .ant-select-selector {
      border: 1px solid #dadada;
      border-radius: 8px;
      background-color: #fff;
      color: #7e7e7e;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 500;
      padding: 5px 13px;
      width: 100%;
      margin-top: 6px;
    }
    .ant-select-arrow {
      background-image: url(${DownAngle});
      background-repeat: no-repeat;
      background-position: 8px 8px;
      border-left: 1px solid #dddddd;
      padding-left: 10px;
      margin-left: 10px;
      min-width: 22px;
      min-height: 22px;
      vertical-align: 0;
      top: 40%;
      span {
        opacity: 0;
      }
    }
  }
  .scrollable {
    width: calc(100% + 25px);
    margin-right: -20px;
    padding-right: 20px;
    padding: 0 20px;
    max-height: calc(100vh - 270px);
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #efefef;
    }
  }
  .footer-sider {
    border-top: 1px solid #e4e4e4;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0px;
    right: 0px;
    margin: 0 20px;
    width: calc(100% - 40px);
    padding: 20px 0;
    .footer-btn {
      font-size: 16px;
      color: #27ce0a;
      padding: 3px 14px;
      font-family: "helveticaneuebold";
      font-weight: 700;
      border-radius: 17px;
      border: 1.56px solid#27CE0A;
      cursor: pointer;
      text-transform: capitalize;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
      &.mr {
        margin-right: 15px;
      }
      &.filled-success {
        background-color: #27ce0a;
        color: #fff;
      }
    }
  }
`;
